import { Container } from '@material-ui/core';

import { NAVIGATION_SECTION_IDS } from 'Constants/NavigationConstants';
import ImagePresenter from 'UI/Components/ImagePresenter/ImagePresenter';
import {useGetHomeContent} from "../../../../../Data/ApiHooks/UseContentHook";
import {BASE_URL} from "../../../../../Constants/Options";

const AboutUs = () => {

  const { data } = useGetHomeContent();

  return (
    <div id={NAVIGATION_SECTION_IDS.aboutUs} className="about-us-section">
      <Container className="about-us-section-top-layer">
        <div className="about-us-section-top-layer__left">
          <div className="title">
            { data?.about_title }
          </div>
          <div className="line" />
          <div className="description">
            { data?.about_description }
          </div>
        </div>
        <div className="about-us-section-top-layer__right" />
      </Container>
      <div className="about-us-section-background-layer">
        <div className="about-us-section-background-layer__left" />
        <ImagePresenter
          containerClass="about-us-section-background-layer__right"
          imageClass="about-us-section-background-layer__right--image"
          src={ BASE_URL + data?.section_image }
        />
      </div>
    </div>
  )
}

export default AboutUs;
